import Vue from 'vue';
import store from '@/store';
import TencentCloudChat from '@tencentcloud/lite-chat'
import {WS_ADDR, IM_APP_ID} from '@/config.js'

let READY_EVENTS = [];
let UNREADY_EVENTS = [];
let init = false, ready = false;
let onlineState = null, onlineTimer;

const IM = TencentCloudChat.create({
	SDKAppID: IM_APP_ID
});
const IMReady = function(event) {
	if (!init) {
		init = true;
		Vue.prototype.request({
			url: '/tim/auth',
			success: data => {
				TencentCloudChat.userID = data.member_account;
				IM.login({
					userID: data.member_account,
					userSig: data.sing
				});
			}
		});
	}

	if (ready) {
		event();
	} else {
		READY_EVENTS.push(event);
	}
}
const IMUnready = function(event) {
	UNREADY_EVENTS.push(event);
}

const online = function() {
	clearTimeout(onlineTimer);
	onlineTimer = setTimeout(() => {
		onlineState = new WebSocket(`${WS_ADDR}/scs/online/${store.state.userInfo.stationed_id}`);
		onlineState.onclose = online;
		onlineState.onerror = online;
	}, 3000);
}

IM.on(TencentCloudChat.EVENT.SDK_READY, () => {
	console.log('SDK_READY');
	ready = true;
	READY_EVENTS.forEach(event => event());
	online();
});
IM.on(TencentCloudChat.EVENT.SDK_NOT_READY, () => {
	console.log('SDK_NOT_READY');
	init = ready = false;
	READY_EVENTS = [];
	UNREADY_EVENTS.forEach(event => event());
	clearTimeout(onlineTimer);
	onlineState && onlineState.close();
	onlineState = null;
});

export default IM
export {TencentCloudChat, IMReady, IMUnready}